function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.235 4.54L11.045.412H3.353a.709.709 0 0 0-.705.712v13.5c0 .394.316.713.705.713h11.176a.709.709 0 0 0 .706-.713V4.539z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M10.825.635v4.2h4.46"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M4.94 7.783h6.448"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.78 9.75l.147 2.898 1.746-2.266 2.174-6.013.008-.022a.964.964 0 0 0-.61-1.22 1.033 1.033 0 0 0-1.298.628L13.779 9.75z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M4.94 10.246h6.448M4.94 12.335h3.214"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M.91 2.542V17.17h12.82"
}));

var SvgDailyDocuments = function SvgDailyDocuments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDailyDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dailyDocuments.c81eef0f.svg";
export { ForwardRef as ReactComponent };